<template>
  <div class="jd_comment_page">
    <!-- Header NavBar -->
    <div class="nav_header" v-if="!isInMiniProgram">
      <div class="back_btn" @click="goBack">
        <van-icon name="arrow-left" />
      </div>
      <div class="nav_title">留言板</div>
      <div class="nav_placeholder"></div>
    </div>

    <!-- Banner Card -->
    <div class="comment_banner">
      <div class="banner_content">
        <h1 class="banner_title">为线上运动会建言助力</h1>
        <p class="banner_subtitle">分享参赛感受、活动建议与健康心得，让运动更有温度</p>
      </div>
      <div class="banner_graphics">
        <!-- SVG Graphic: Mailbox and Running Path -->
        <svg viewBox="0 0 100 80" class="banner_svg">
          <defs>
            <linearGradient id="mailGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#4ADE80" />
              <stop offset="100%" stop-color="#166534" />
            </linearGradient>
          </defs>
          <!-- Mailbox -->
          <rect x="55" y="15" width="30" height="45" rx="6" fill="url(#mailGrad)" />
          <rect x="50" y="60" width="40" height="4" rx="2" fill="#15803D" />
          <rect x="67" y="64" width="6" height="12" fill="#166534" />
          <!-- Mailbox opening -->
          <rect x="60" y="22" width="20" height="5" rx="1.5" fill="#14532D" />
          <!-- Letter coming out -->
          <path d="M62,18 L78,18 L78,25 L62,25 Z" fill="#FEF08A" stroke="#EAB308" stroke-width="1" />
          <polygon points="62,18 70,22 78,18" fill="#FEF9C3" stroke="#EAB308" stroke-width="1" />
          <!-- Running girl simple outline -->
          <circle cx="25" cy="25" r="5" fill="#166534" />
          <path d="M25,30 L28,45 L38,55 M28,40 L18,52 M25,33 L35,30 L42,38 M25,33 L15,35 L12,42" stroke="#166534" stroke-width="3" stroke-linecap="round" fill="none" />
          <!-- Little stars/leaves -->
          <circle cx="15" cy="18" r="2" fill="#4ADE80" />
          <circle cx="48" cy="28" r="1.5" fill="#4ADE80" />
          <path d="M42,48 C44,45 48,46 50,44" stroke="#4ADE80" stroke-width="1" fill="none" />
        </svg>
      </div>
    </div>

    <!-- Comments List Section -->
    <div class="comments_section">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          class="comments_list"
        >
          <div v-for="item in list" :key="item.id" class="comment_card">
            <div class="comment_header">
              <div class="user_avatar">
                <img :src="item.avatar || defaultAvatar" alt="avatar" />
              </div>
              <div class="user_meta">
                <span class="user_nickname">{{ item.nickname }}</span>
                <span class="comment_date">{{ formatTime(item.create_time) }}</span>
              </div>
            </div>
            <div class="comment_body">
              <p class="comment_text">{{ item.content }}</p>
            </div>
          </div>

          <!-- Empty State -->
          <div v-if="list.length === 0 && !loading" class="empty_state">
            <van-icon name="chat-o" class="empty_icon" />
            <p>暂无留言，快来抢沙发吧～</p>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <!-- Sticky Bottom Bar -->
    <div class="bottom_action_bar">
      <div class="input_placeholder_btn" @click="openWritePopup">
        <van-icon name="edit" class="edit_icon" />
        <span>写下你的想法...</span>
      </div>
      <div class="publish_btn" @click="openWritePopup">
        <svg viewBox="0 0 24 24" class="send_svg_icon" fill="currentColor">
          <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
        </svg>
        <span>发布留言</span>
      </div>
    </div>

    <!-- Bottom Publisher Sheet -->
    <van-popup
      v-model="showWritePopup"
      position="bottom"
      round
      class="publisher_popup"
      :safe-area-inset-bottom="true"
    >
      <div class="publisher_header">
        <span class="cancel_btn" @click="closeWritePopup">取消</span>
        <span class="popup_title">写留言</span>
        <van-button
          type="primary"
          size="small"
          :loading="submitting"
          class="submit_btn"
          @click="submitComment"
        >
          发送
        </van-button>
      </div>
      <div class="publisher_body">
        <textarea
          v-model="commentContent"
          rows="5"
          maxlength="150"
          placeholder="分享你的参赛感受、活动建议与健康心得吧（最多150字）"
          class="comment_textarea"
          ref="commentField"
        ></textarea>
        <span class="word_count">{{ commentContent.length }}/150</span>
     </div>
    </van-popup>
  </div>
</template>

<script>
import "./comment.less"
import { Icon, PullRefresh, List, Popup, Button, Toast } from "vant";
import moment from "moment";

export default {
  name: "SportsCommentBoard",
  components: {
    [Icon.name]: Icon,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Popup.name]: Popup,
    [Button.name]: Button
  },
  props: ["sports_id"],
  data() {
    return {
      sportid: this.sports_id || this.$route.params.sports_id,
      list: [],
      page: 1,
      loading: false,
      finished: false,
      refreshing: false,
      showWritePopup: false,
      commentContent: "",
      submitting: false,
      userInfo: {},
      defaultAvatar: "https://oss.mcloud.moveclub.cn/2025/qjyd-hu/%E6%A4%AD%E5%9C%86%20250%402x.png",
      isRegistered: false,
      registerMode: 1,
      isInMiniProgram: false
    };
  },
  mounted() {
    this.checkMiniProgram();
    this.getUserInfo().then(() => {
      this.getSportsDetail();
    }).catch(() => {
      this.getSportsDetail();
    });
  },
  methods: {
    checkMiniProgram() {
      const ua = window.navigator.userAgent.toLowerCase();
      if (
        /miniProgram/i.test(ua) ||
        window.__wxjs_environment === 'miniprogram' ||
        this.$route.query.isMiniProgram === '1' ||
        this.$route.query.from === 'miniprogram'
      ) {
        this.isInMiniProgram = true;
      }
      // Listen for WeChat SDK environment detection
      document.addEventListener('WeixinJSBridgeReady', () => {
        if (window.__wxjs_environment === 'miniprogram') {
          this.isInMiniProgram = true;
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    getUserInfo() {
      return this.$api.user.getUserInfo().then((res) => {
        if (res && res.status * 1 === 200) {
          this.userInfo = res.data;
        }
      }).catch(e => console.warn(e));
    },
    getSportsDetail() {
      this.$api.sports.sportsMain(this.sportid).then((res) => {
        if (res && res.data) {
          this.registerMode = res.data.register_mode;
          if (res.data.register_mode == 2) {
            this.isRegistered = !!res.data.is_registered;
          } else {
            this.checkActivityRegistration();
          }
        }
      }).catch(e => console.warn(e));
    },
    checkActivityRegistration() {
      this.$api.activity.getCombine({ combile_id: 52 }).then((res) => {
        if (res && res.data) {
          let { registerinfos } = res.data;
          this.isRegistered = !!registerinfos;
        }
      }).catch(e => console.warn(e));
    },
    onLoad() {
      this.getCommentsList();
    },
    onRefresh() {
      this.finished = false;
      this.page = 1;
      this.getCommentsList(true);
    },
    getCommentsList(isRefresh = false) {
      if (isRefresh) {
        this.refreshing = true;
      }
      this.loading = true;
      const params = {
        sports_id: this.sportid,
        page: this.page,
        page_size: 15
      };
      this.$api.sports.getComments(params).then((res) => {
        this.loading = false;
        this.refreshing = false;
        if (res && res.status * 1 === 200) {
          const fetchedList = res.data.list || [];
          if (isRefresh) {
            this.list = fetchedList;
          } else {
            this.list = [...this.list, ...fetchedList];
          }
          
          this.page++;
          if (fetchedList.length < 15) {
            this.finished = true;
          }
        } else {
          this.finished = true;
          this.$toast(res.message || "加载失败");
        }
      }).catch(err => {
        this.loading = false;
        this.refreshing = false;
        this.finished = true;
        console.error(err);
      });
    },
    openWritePopup() {
      // Ensure user is logged in
      if (!this.userInfo || !this.userInfo.urid) {
        this.$toast("请先登录");
        return;
      }
      if (!this.isRegistered) {
        this.$toast("您需要先报名才能发布留言");
        return;
      }
      this.commentContent = "";
      this.showWritePopup = true;
      this.$nextTick(() => {
        if (this.$refs.commentField) {
          this.$refs.commentField.focus();
        }
      });
    },
    closeWritePopup() {
      this.showWritePopup = false;
    },
    submitComment() {
      if (!this.isRegistered) {
        this.$toast("您需要先报名才能发布留言");
        return;
      }
      const content = this.commentContent.trim();
      if (!content) {
        this.$toast("请输入留言内容");
        return;
      }
      
      this.submitting = true;
      const params = {
        token: this.$storage.get("token") || this.$route.query.token,
        urid: this.userInfo.urid,
        sports_id: this.sportid,
        content: content
      };

      this.$api.sports.submitComment(params).then((res) => {
        this.submitting = false;
        if (res && res.status * 1 === 200) {
          this.$toast.success("提交成功，请等待审核！");
          this.showWritePopup = false;
          // Refresh list to fetch newly approved or show current
          this.onRefresh();
        } else {
          this.$toast(res.message || "提交失败");
        }
      }).catch(err => {
        this.submitting = false;
        this.$toast("提交网络异常");
        console.error(err);
      });
    },
    formatTime(timestamp) {
      if (!timestamp) return "";
      return moment(timestamp * 1000).format("YYYY-MM-DD HH:mm");
    }
  }
};
</script>
